import { setTheme } from "theme/default/setTheme";

export const setFontSize_14px = setTheme(({ theme }) => `font-size: ${theme.fontSize.font_size_14px}`);
